// The PDF pane's rotate buttons (owner, 2026-10-01). Kept out of PdfPane.tsx so
// the component file exports components only, and out of pdfRender.ts so
// importing it does not pull PDF.js into the main bundle.

/** Degrees in one click of a rotate button. */
export const ROTATION_STEP = 90

/**
 * Any whole multiple of 90 degrees, folded to 0, 90, 180 or 270. Anything else
 * - undefined, NaN, 45, a hand-typed `?rotate=abc` - is 0, so a bad value in
 * the Full Screen link opens the page upright rather than at an odd angle.
 */
export function normalizeRotation(degrees: number | undefined): number {
  if (degrees === undefined || !Number.isFinite(degrees) || degrees % ROTATION_STEP !== 0) return 0
  return ((degrees % 360) + 360) % 360
}

/** The `?rotate=` value of a Full Screen link, read the same forgiving way. */
export function rotationFromSearch(search: string): number {
  const raw = new URLSearchParams(search).get('rotate')
  return raw === null || raw.trim() === '' ? 0 : normalizeRotation(Number(raw))
}
